import "./publisherList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect } from "react";
import Datatable from "../../components/datatable/Datatable";

const PublisherList = () => {
  useEffect(() => {
    document.title = "Wishallbook >> Publishers";
  }, []);

  return (
    <div className="publisherList">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <Datatable type="publishers" />
      </div>
    </div>
  );
};

export default PublisherList;
